import { CsvLogo } from "assets/images";
import CustomModal from "components/Modal/CustomModal";
import ProfileContext from "context/ProfileContext";
import CsvView from "Pages/CSV/CsvView";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Spinner, Table, Tabs } from "react-bootstrap";
import { CaretDown, CaretUp, Search } from "react-bootstrap-icons";
import HostAcceptedList from "./HostAcceptedList";
import "./hostlisting.css";
import { Field, Form, Formik } from "formik";
import InfiniteScroll from 'react-infinite-scroll-component';

const HostRevenueList = () => {
  let {
    updateHostRevenue,
    updatedRevenue,
    nextStepHostRevenue,
  } = useContext(ProfileContext);
  const [loadingPros, setLoadingPros] = useState(false);
  const [searchTerminologyRev, setSearchTerminologyRev] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [sortStatus, setSortStatus] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  // Fetch more data for infinite scroll (scoped to this tab container)
  const fetchMoreData = useCallback(() => {
    if (!hasMore || loadingPros || !nextStepHostRevenue) return;
    setLoadingPros(true);
    const res = updateHostRevenue(new URL(nextStepHostRevenue).search, true);
    res
      .then(() => {
        setLoadingPros(false);
        if (!nextStepHostRevenue) {
          setHasMore(false);
        }
      })
      .catch(() => {
        setLoadingPros(false);
      });
  }, [hasMore, loadingPros, nextStepHostRevenue, updateHostRevenue]);

  // Reset hasMore when search or sort changes
  useEffect(() => {
    setHasMore(true);
  }, [searchTerminologyRev, sortStatus]);

  const getAcceptedHosts = () => {
    if (updatedRevenue?.length < 1 && !loadingPros) {
      return (
        <tr>
          <td colSpan="4">Not any revenue generated yet!</td>
        </tr>
      );
    } else {
      const hostRows = updatedRevenue?.map((updatedRevenue, index) => {
        return <HostAcceptedList key={`${updatedRevenue.id || index}`} hostDetails={updatedRevenue} />;
      });

      // Add loading spinner at the end when loading more
      if (loadingPros && updatedRevenue && updatedRevenue.length > 0) {
        hostRows.push(
          <tr key="loading">
            <td colSpan="4">
              <div className="d-flex justify-content-center py-3">
                <Spinner animation="grow" />
                <Spinner animation="grow" />
                <Spinner animation="grow" />
              </div>
            </td>
          </tr>
        );
      }

      return hostRows;
    }
  };

  return (
    <div>
      <div className="header_revenue_page d-flex justify-content-end">
        <div className="search-wrapper col-md-4 col-sm-5 mb-3">
          <Formik
            initialValues={{ searchterm: "" }}
            onSubmit={(value) => {
              setLoadingPros(true);
              setHasMore(true);
              let res = updateHostRevenue(
                `order=true&search=${value.searchterm}`
              );
              res.then(() => setLoadingPros(false));
            }}
          >
            {({ setFieldValue, values }) => (
              <Form>
                <div className="row">
                  <div className="col-12 d-flex">
                    <Field
                      type="search"
                      placeholder="Search"
                      className="form-control"
                      onChange={(e) => {
                        setSearchTerminologyRev(e.target.value);
                        setFieldValue("searchterm", e.target.value);
                      }}
                      value={values.searchterm}
                      name="searchterm"
                    />
                    <button type="submit" className="search magnifier">
                      <Search />
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>

        <div className="csv-wrapper text-end">
          <img
            className="csv-download"
            onClick={handleShow}
            src={CsvLogo}
            alt="csv"
          />
          <CustomModal
            showStatus={show}
            clickStatus={handleClose}
            buttonMessage="Close"
            closeStatus={handleClose}
            title="Photo"
            message={<CsvView type="store-host-detail" />}
            secondMessage="none"
            secondButton={false}
          />
        </div>
      </div>
      <div id="revenueScrollableDiv" style={{ height: '600px', overflow: 'auto' }}>
        <InfiniteScroll
          dataLength={updatedRevenue?.length || 0}
          next={fetchMoreData}
          hasMore={hasMore}
          loader={
            loadingPros && updatedRevenue?.length > 0 && (
              <div className="d-flex justify-content-center py-3">
                <Spinner animation="grow" />
                <Spinner animation="grow" />
                <Spinner animation="grow" />
              </div>
            )
          }
          scrollableTarget="revenueScrollableDiv"
          endMessage={
            <div className="text-center py-3 text-muted">
              {!hasMore && updatedRevenue?.length > 0 && "You have seen all host revenues!"}
            </div>
          }
        >
        <Table className="table-store" responsive>
          <thead>
            <tr>
              <th scope="col">
                <div className="arrows">
                  Real Customer{" "}
                  <div
                    className="arrow-grid"
                    onClick={() => {
                      setLoadingPros(true);
                      setSortStatus(!sortStatus);
                      setHasMore(true);
                      let res = updateHostRevenue(
                        `order=true&host=${sortStatus}&search=${searchTerminologyRev}`
                      );
                      res.then(() => setLoadingPros(false));
                    }}
                  >
                    <CaretUp />
                    <CaretDown />
                  </div>
                </div>
              </th>
              <th scope="col">
                <div className="arrows">
                  Revenue{" "}
                  <div
                    className="arrow-grid"
                    onClick={() => {
                      setLoadingPros(true);
                      setSortStatus(!sortStatus);
                      setHasMore(true);
                      let res = updateHostRevenue(
                        `order=true&revenue=${sortStatus}&search=${searchTerminologyRev}`
                      );
                      res.then(() => setLoadingPros(false));
                    }}
                  >
                    <CaretUp />
                    <CaretDown />
                  </div>
                </div>
              </th>
              <th scope="col">
                <div className="arrows">
                  Earnings{" "}
                  <div
                    className="arrow-grid"
                    onClick={() => {
                      setLoadingPros(true);
                      setSortStatus(!sortStatus);
                      setHasMore(true);
                      let res = updateHostRevenue(
                        `order=true&earning=${sortStatus}&search=${searchTerminologyRev}`
                      );
                      res.then(() => setLoadingPros(false));
                    }}
                  >
                    <CaretUp />
                    <CaretDown />
                  </div>
                </div>
              </th>
              <th scope="col">
                <div className="arrows">Top Product</div>
              </th>
            </tr>
          </thead>
          <tbody>{getAcceptedHosts()}</tbody>
        </Table>
        </InfiniteScroll>
      </div>
      
      {/* Show loading spinner for initial load */}
      {loadingPros && (!updatedRevenue || updatedRevenue.length === 0) && (
        <div className="d-flex justify-content-center py-4">
          <Spinner animation="grow" />
          <Spinner animation="grow" />
          <Spinner animation="grow" />
        </div>
      )}
    </div>
  );
};

export default HostRevenueList;